/* eslint-disable @typescript-eslint/no-unsafe-return */
import { AxiosResponse } from 'axios';

import type {
  QuantityGetDto,
  ChangeStockTransactionDto,
  RemoveStockTransactionAddDto,
  StockTransactionAddDto,
  StockTransactionGetDto,
  LocationDto,
  ChangeLocationDto,
  ProductWithQuantitiesGetDto,
  ResultQuantitiesGetDto,
  OrderProductGetDTO,
} from 'svila-common';
import { LocationWithQuantitiesDto } from '~/src/scenes/orders/orders/pages/palletDescription/PalletDescriptions';
import { OrderProductWithReservedQuantityGetDto, OrderWithProductsGetDto } from '~/src/types/Misc';

import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  cleanupOrders: async (v) => {
    const url = `${API_URL}/temp/cleanup-order`;
    // convert orderNumber in v to int
    v.orderNumber = parseInt(v.orderNumber, 10);
    return request(url, 'post', v.orderNumber);
  },
};
